export const getMetadataProduct = (item) => {
  const hasPackageLevel = Boolean(item?.packageLevel);
  const hasGtin = Boolean(item?.gtin);
  const hasUpc12 = Boolean(item?.upc12);

  if (hasPackageLevel) {
    let result = `${item.packageLevel}`;

    if (hasGtin) return result + ` / ${item.gtin}`;

    if (hasUpc12) return result + ` / ${item.upc12}`;

    return result;
  } else {
    if (hasGtin) return `${item.gtin}`;

    if (hasUpc12) return `${item.upc12}`;

    return 'N/A';
  }
};
